import CalculatorsController from '../../src/javascripts/cvm';
import SymplrCvo from '../../src/javascripts/models/symplr/cvo';
import '../../src/javascripts/helpers/application/fa_checkbox_helper';
// import '../../src/javascripts/helpers/application/self_service_pdf_launcher';
import '../../src/javascripts/helpers/symplr/cvo/hubspot_helpers';
import '../../src/javascripts/helpers/symplr/cvo/production_selection_dependencies';
import '../../src/javascripts/helpers/symplr/cvo/calculated_fields_helper';
import '../../src/stylesheets/symplr/symplr_shared.scss';
import '../../src/stylesheets/symplr/cvo.scss';

(function() {
  $(() => CalculatorsController.run(new SymplrCvo()));
}).call(this);
